import type { Config } from 'tailwindcss'

export default {
    corePlugins: {
        preflight: false, //disable this so it doesn't mess with antdesign default styling
    },
    mode: 'jit',
    content: ['./src/**/*.{js,jsx,ts,tsx}'],
    theme: {
        extend: {
            colors: {
                allgrey: '#F6F7FB',
            },
        },
        borderColor: ({ theme }) => ({
            ...theme('colors'),
            DEFAULT: '#d0d4e4',
        }),
    },

    plugins: [],
} satisfies Config
